import { useAuthState } from '../../hooks/useAuthState'

export const useNestedFolders = (): boolean => {
  const { isAuthenticated, hasOperation } = useAuthState()
  return isAuthenticated && hasOperation('view:nested_folders')
}
